import { render, staticRenderFns } from "./DisconnectorTab.vue?vue&type=template&id=79711dfc&scoped=true&"
import script from "./DisconnectorTab.vue?vue&type=script&lang=js&"
export * from "./DisconnectorTab.vue?vue&type=script&lang=js&"
import style0 from "./DisconnectorTab.vue?vue&type=style&index=0&id=79711dfc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79711dfc",
  null
  
)

export default component.exports